
import React, {  useState, useEffect, useMemo } from 'react';
import LanguageContext from './LanguageContext';
import i18n from '../languagesetup';
import { useGetcontentsdata } from '../Language/languageApi';
import Loader from '../../Loader/buttonLoad';
import PropTypes from 'prop-types';

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(localStorage.getItem('Lang') || 'english');
  const { data: langagedata, isLoading, error } = useGetcontentsdata({ language });
  
  useEffect(() => {
    if (langagedata) {
      const translations = { english: {}, french: {}, Portuguese: {} };
      langagedata?.data.forEach(item => {
        if (item.Keyvalue) {
          translations.english[item.Keyvalue] = item.english || '';
          translations.Portuguese[item.Keyvalue] = item.Portuguese || '';
          translations.french[item.Keyvalue] = item.french || '';
        }
      });
      i18n.addResourceBundle('english', 'translation', translations.english, true, true);
      i18n.addResourceBundle('Portuguese', 'translation', translations.Portuguese, true, true);
      i18n.addResourceBundle('french', 'translation', translations.french, true, true);
    }
    i18n.changeLanguage(localStorage.getItem('Lang'));
  }, [langagedata , language]);
  
  const changeLanguage = (lng) => {
    setLanguage(lng);
    localStorage.setItem('Lang',lng)
    i18n.changeLanguage(lng);
  };
  const value = useMemo(() => ({
     language,changeLanguage
  }), [ language,changeLanguage]);

  if (isLoading) return <Loader/>;
  if (error) return <div>Error loading languages</div>;


  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

LanguageProvider.propTypes = {
    children: PropTypes.any,

}